import type { RenderInTopNavSignature } from '@efdigital/ll-addon-content/types/components/parts/render-in-top-nav';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import BsNavBar from 'ember-bootstrap/components/bs-navbar';

const RenderInTopNav: TemplateOnlyComponent<RenderInTopNavSignature> =
  <template>
    <div class="va-program-top-nav">
      <div class="container">
        <BsNavBar
          @type="light"
          @backgroundColor="white"
          @fluid={{false}}
          @position="sticky-top"
          class="border-bottom mb-5"
          as |navbar|
        >
          <LinkTo @route="index" class="navbar-brand d-flex flex-column py-2">
            <span class="fw-bold fs-4 lh-1"><span
                class="text-primary"
              >X</span>ceed</span>
            <span class="fw-medium fs-6 lh-1">E<span
                class="text-primary"
              >x</span>ecEd Online</span>
          </LinkTo>
          <navbar.toggle />
          <navbar.content>
            <navbar.nav class="fs-6 fw-semibold flex-grow-1" as |nav|>
              {{yield nav to="main"}}
            </navbar.nav>
            <navbar.nav class="fs-6 fw-semibold" as |nav|>
              {{yield nav to="utility"}}
            </navbar.nav>
          </navbar.content>
        </BsNavBar>
      </div>
    </div>
  </template>;

export { RenderInTopNav };
